
import React, { Component } from "react";
import { Alert, Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// action
import { forgetUser, resetForgetPWState } from '../../store/actions';

// import images
import { InputAdornment, Stack, TextField } from "@mui/material";
import logodark from "../../assets/images/Aspeed_Logo.png";
import withRouter from "../../components/Common/withRouter";
import LoadingDialog from "../../components/Common/LoadingDialog";
import CustomButton from "../../components/Form/CustomButton";
import CustomTextField from "../../components/Form/CustomTextField";

class ForgetPasswordPage extends Component {
    constructor(props) {
        super(props);
        this.state = { loading: false, email: '' };

        // handleValidSubmit
        this.handleValidSubmit = this.handleValidSubmit.bind(this);
        this.props.resetForgetPWState();
    }

    // handleValidSubmit
    handleValidSubmit() {
        this.setState({ loading: true });
        const values = {
            email: this.state.email,
        }
        this.props.forgetUser(values);
        this.setState({ loading: false });
    }

    render() {
        return (
            <React.Fragment>
                <div>
                    <LoadingDialog open={this.props.loading} />
                    <Container fluid className="p-0">
                        <Row className="g-0">
                            <Col lg={12}>
                                <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                                    <div className="w-100">
                                        <Row className="justify-content-center">
                                            <Col lg={4}>
                                                <div>
                                                    <div className="text-center">
                                                        <div>
                                                            <Link to="/" className="logo"><img src={logodark} height="100" alt="logo" /></Link>
                                                        </div>

                                                    </div>
                                                    <Card className='p-4 mt-4' style={{ borderRadius: 10 }}>
                                                        <CardBody>
                                                            <div style={{ fontSize: 24, fontFamily: 'Manrope-SemiBold' }}>Reset Password</div>
                                                            <p className="text-muted">Reset your password to A-Speed Admin Portal.</p>
                                                            <div className="mt-2">
                                                                {this.props.message?.code === "error" ?
                                                                    <Alert color="danger" className="mb-4">{this.props.message?.data?.message}</Alert> : null}
                                                                {
                                                                    this.props.message?.code === "success" ?
                                                                        <Alert color="success" className="mb-4">{this.props.message?.data?.message}</Alert> : null
                                                                }

                                                                <Stack flexDirection="column" mt={2}>
                                                                    <CustomTextField
                                                                        error={this.props.message?.errors?.email}
                                                                        title={'Email address'}
                                                                        values={this.state.email}
                                                                        onChange={(e) => this.setState({ email: e })}
                                                                    />

                                                                </Stack>
                                                                <div className="mt-4 text-center">
                                                                    <CustomButton
                                                                        title={this.props.loading ? "Loading..." : "Reset Password"}
                                                                        disabled={this.props.loading}
                                                                        backgroundColor={'var(--bs-theme-color)'}
                                                                        textColor={'white'}
                                                                        width={'100%'}
                                                                        borderRadius={8}
                                                                        press={() => this.handleValidSubmit()}
                                                                    />
                                                                </div>
                                                                <div className="mt-4 text-center">
                                                                    <Link to="/login" className="text-muted"><i className="mdi mdi-lock me-1"></i> Go Back to Sign In</Link>
                                                                </div>
                                                            </div>
                                                        </CardBody>
                                                    </Card>
                                                </div>

                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </Col>
                            {/* <Col lg={8}>
                                <div className="authentication-bg">
                                    <div className="bg-overlay"></div>
                                </div>
                            </Col> */}
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    const { message, forgetError, loading } = state.Forget;
    return { message, forgetError, loading };
}

export default withRouter(
    connect(mapStatetoProps, { forgetUser, resetForgetPWState })(ForgetPasswordPage)
);
